import React from 'react';
import { FiFacebook, FiInstagram } from 'react-icons/fi';
import { FaXTwitter } from "react-icons/fa6";
import { images } from '../../constants';
import { FooterOverlay} from '../../components';
import './Footer.css';

const Footer = () => (
  <div className='app__footer section__padding'>
    <FooterOverlay/>
    <div className='app_footer-apps'  >
      <h1 className='app__footer-headtext' style={{ textAlign: 'center', fontSize: 30 }}   id='footer' >Apps para delivery</h1>
      <div className='app__footer-apps_logo'>
        <img src={images.app1} alt="app" className='app__img'/>
        <img src={images.app2} alt="app" className='app__img'/>
        <img src={images.app3} alt="app" className='app__img'/>
      </div>
    </div>
    <div className='app__footer-links'>
      <div className='app__footer-links_contact'>
        <h1 className='app__footer-headtext' style={{ textAlign: 'center', fontSize: 30 }}>Ubicación</h1>
        <p className='p__opensans'>Barros Arana, Gran Concepción</p>
        <h1 className='app__footer-headtext' style={{ textAlign: 'center', fontSize: 30 }}>Teléfonos</h1>
        <p className='p__opensans'>+562 2459 7642</p>
        <p className='p__opensans'>+569 4265 8264</p>
      </div>
      <div className='app__footer-links_logo'>
        <img src={images.roll} alt="roll" className='roll__img' style={{ marginTop: -35}} />
        <div className='app__footer-links_icons'>
            <FiFacebook />
            <FaXTwitter />
            <FiInstagram />
        </div>
      </div>
      <div className='app__footer-links_work'>
        <h1 className='app__footer-headtext' style={{ textAlign: 'center', fontSize: 30 }}>Horario de atención</h1>
        <p className='p__opensans'>Lunes a viernes:</p>
        <p className='p__opensans'> 10:00 - 20:30 </p>
        <p className='p__opensans'>Sábados y domingos:</p>
        <p className='p__opensans'> 12:00 - 18:00 </p>
      </div>
    </div>
    <div className='footer__copyright'>
      <p className='p__cormorant' style={{ textAlign: 'center' }}>Rodrigo Mardones © 2024</p>
    </div>
  </div>
);

export default Footer;
